import React from 'react';
import { Dialog, DialogActions, DialogContent, Button, TextField, Switch, Fab, Grid, Avatar, Divider } from '@material-ui/core'
import Utils from '../../providers/Utils';
import LocalStorage from '../../providers/LocalStorage';
import Ws from '../../providers/Ws';
import avatar from '../../Pics/avatar.jpg'
import SpecificComponent from '../SpecificComponent';
import ConcediuDialog from './ConcediuDialog';
import ConcediuDialogNew from './ConcediuDialogNew';

import { ReactComponent as TrashAltSolid } from '../../Pics/iconsManagementUtilizatori/Trash.svg'
import { ReactComponent as PenSolid } from '../../Pics/iconsManagementUtilizatori/Edit.svg'
import Masks from '../../providers/Masks';
import ProgramatorLuni from '../monthComponent/ProgramatorLuni';

import { ReactComponent as HistoryToggle } from '../../module/monitorizare/MonitorizareIcons/history_toggle_off_black.svg';
import { ReactComponent as FaceBlack } from '../../module/monitorizare/MonitorizareIcons/face_black.svg';


export default class DetaliiConcediiAngajat extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            eveniment: { la_data: this.u.defaultData(), tip_concediu: '', prezenta: null, id_concediu: '', },
            openUpdateEveniment: false,
            openInsertEveniment: false,
            pontaje: [],
            nrZileConcediu: this.props.angajat.nr_zile_concediu,
            dataInceput: this.u.defaultData(),
            dataInceputPlus1: this.u.defaultDataPlus1Months(),
            dataInceputMinus1: this.u.defaultDataMinus1Months(),
            dataSfarsit: this.u.defaultData(),
            tipConcediu: 'prezent',
            tipuriConcedii: this.u.tipConcedii,
            oraInceput: '00:00',
            oraFinalizare: '00:00',
            existaPontaj: '',
            peOLuna: true,
            maxWidth: 'md'


        }
    }

    componentDidMount() {
        this.getPontaje(this.props.angajat)

    }

    ws = new Ws()
    u = new Utils()
    m = new Masks()
    ls = new LocalStorage()
    pontaje = []
    concedii = []


    numeAvatar = (nume) => {

        if (nume) {
            let n = nume.split(' ')

            // console.log('n :>> ', n);

            let firstLetters = ''

            if (n[0]) {

                firstLetters += n[0].substring(0, 1)

            }
            if (n[1]) {
                firstLetters += n[1].substring(0, 1)
            }

            firstLetters = firstLetters.toUpperCase()

            return firstLetters
        } else {
            return 'NA'
        }


    }

    handleDate = (ev, name) => {
        // console.log('ev :', ev);
        // console.log('name :', name);

        if (name === 'perioada_dela') {

            this.setState({ dataInceput: new Utils().transformDataForSql(ev) })




        } else {
            this.setState({ dataSfarsit: new Utils().transformDataForSql(ev) })
        }




    }



    getPontaje = async (a) => {


        console.warn('a :>> ', a);
        let _concedii = this.ws.customSelect(`select c.*, p.id_angajat from concedii c left outer join pontaje p on p.id_concediu = c.id
        where (year(c.cand_inceput_data) = year(@p1) OR year(c.cand_sfarsit_data) = year(@p1)) and isnull(p.sters,0) != 1  and p.id_angajat = @p3` , {
            p1: this.props.dataStart,
            p2: this.props.dataEnd,
            p3: a.id
        })
        // let _concedii = this.ws.customSelect('select * from concedii where 1 = @p1',{p1:1})

        let _pontaje = this.ws.customSelect(`select * from pontaje where year(la_data) = year(@p1) and isnull(sters,0) != 1 and id_angajat = @p2`, {
            p1: this.props.dataStart,
            p2: a.id
        })






        let [pontaje, concedii] = await Promise.all([_pontaje, _concedii])

        console.log('pontaje :>> ', pontaje);
        console.log('concedii :>> ', concedii);

        if (pontaje.Succes && concedii.Succes) {

            console.log('this.props.angajat :>> ', this.props.angajat);

            this.pontaje = pontaje.Content
            this.concedii = concedii.Content
            let nrZileConcediu = 21

            for (let i = 0, n = this.pontaje.length; i < n; i++) {

                let idx = this.concedii.findIndex(c => c.id === this.pontaje[i].id_concediu)

                let idxProgram = this.props.angajat['zile_libere'].findIndex(p => p === new Date(this.u.ParseDataFromSql(this.pontaje[i]['la_data'])).getDay())
                // console.log('idx :', idx);

                this.pontaje[i].color = 'transparent'


                if (idxProgram === -1) {

                    if (Number(this.pontaje[i].prezent_azi) === 1 && this.pontaje[i].tip !== 'ore_suplimentare') {



                        this.pontaje[i].color = 'rgb(135 226 167)'
                    }

                    else if (this.pontaje[i].tip === 'absenta_invoire') {





                        this.pontaje[i].cand_inceput_oraC = this.pontaje[i].cand_inceput_ora ? this.u.transformTimeFromSql(this.pontaje[i].cand_inceput_ora) : '08:00'
                        this.pontaje[i].cand_sfarsit_oraC = this.pontaje[i].cand_sfarsit_ora ? this.u.transformTimeFromSql(this.pontaje[i].cand_sfarsit_ora) : '18:00'
                        this.pontaje[i].color = 'rgb(206, 152, 79)'

                        console.warn('absenta_invoire ANgajat :>> ', this.pontaje[i]);



                    }

                    else if (this.pontaje[i].tip === 'invoire') {




                        this.pontaje[i].cand_inceput_oraC = this.pontaje[i].cand_inceput_ora ? this.u.transformTimeFromSql(this.pontaje[i].cand_inceput_ora) : '08:00'
                        this.pontaje[i].cand_sfarsit_oraC = this.pontaje[i].cand_sfarsit_ora ? this.u.transformTimeFromSql(this.pontaje[i].cand_sfarsit_ora) : '18:00'
                        this.pontaje[i].color = 'rgb(112 227 255)'





                    } else if (this.pontaje[i].tip === 'ore_suplimentare') {




                        this.pontaje[i].cand_inceput_oraC = this.pontaje[i].cand_inceput_ora ? this.u.transformTimeFromSql(this.pontaje[i].cand_inceput_ora) : '08:00'
                        this.pontaje[i].cand_sfarsit_oraC = this.pontaje[i].cand_sfarsit_ora ? this.u.transformTimeFromSql(this.pontaje[i].cand_sfarsit_ora) : '18:00'
                        this.pontaje[i].color = 'rgb(14 111 28)'




                    }


                    else if (this.pontaje[i].absent_azi === 1) {
                        this.pontaje[i].color = 'rgb(227 51	59)'
                    }


                } else if (this.pontaje[i].tip === 'ore_suplimentare') {
                    this.pontaje[i].cand_inceput_oraC = this.pontaje[i].cand_inceput_ora ? this.u.transformTimeFromSql(this.pontaje[i].cand_inceput_ora) : '08:00'
                    this.pontaje[i].cand_sfarsit_oraC = this.pontaje[i].cand_sfarsit_ora ? this.u.transformTimeFromSql(this.pontaje[i].cand_sfarsit_ora) : '18:00'
                    this.pontaje[i].color = 'rgb(14 111 28)'
                }



                if (idx !== -1) {
                    this.pontaje[i].cand_inceput_dataC = this.concedii[idx].cand_inceput_data
                    this.pontaje[i].cand_sfarsit_dataC = this.concedii[idx].cand_sfarsit_data
                    this.pontaje[i].tip_concediu = this.concedii[idx].tip_concediu


                    let getDaysConcediu = this.u.generateListaZile(new Date(this.u.ParseDataFromSql(this.pontaje[i].cand_inceput_dataC)), new Date(this.u.ParseDataFromSql(this.pontaje[i].cand_sfarsit_dataC)))

                    console.log('getDaysConcediu :>> ', getDaysConcediu);





                    let idxConcediu = this.u.tipConcedii.findIndex(tp => tp.id === this.concedii[idx].tip_concediu)

                    if (idxConcediu !== -1) {
                        this.pontaje[i].nume_concediu = this.u.tipConcedii[idxConcediu].nume
                    }




                    if (this.pontaje[i].tip_concediu === 'concediu_fara_plata') {
                        this.pontaje[i].color = 'rgb(250 113 117)'
                    } else if (this.pontaje[i].tip_concediu === 'concediu_odihna') {
                        this.pontaje[i].color = 'rgba(38 120 227)'
                    } else if (this.pontaje[i].tip_concediu === 'concediu_medical') {
                        this.pontaje[i].color = 'rgb(252 99	7)'
                    } else if (this.pontaje[i].tip_concediu === 'concediu_ingrijire_copil') {
                        this.pontaje[i].color = 'rgb(241 23 168)'
                    } else if (this.pontaje[i].tip_concediu === 'evenimente_speciale') {
                        this.pontaje[i].color = 'rgb(238 231 24)'
                    } else if (this.pontaje[i].tip_concediu === 'preaviz') {
                        this.pontaje[i].color = 'rgb(21	164	191)'
                    } else {
                        this.pontaje[i].color = 'transparent'
                    }

                    console.log('pontaje :>> ', this.pontaje);
                    console.log('this.props.angajat :>> ', this.props.angajat);


                    if (this.concedii[idx].tip_concediu === 'concediu_odihna') {

                        for (let k = 0, l = getDaysConcediu.length; k < l; k++) {

                            if (this.props.angajat['zile_libere'].findIndex(p => p === new Date(getDaysConcediu[k]).getDay()) !== -1) {
                                console.log('+ 1 :>> ');
                                nrZileConcediu += 1
                            }

                        }


                        let daysDifference = this.u.getDaysDifference(this.pontaje[i].cand_sfarsit_dataC, this.pontaje[i].cand_inceput_dataC)

                        nrZileConcediu = nrZileConcediu - daysDifference

                    }

                }


            }

            this.setState({
                pontaje: this.pontaje,
                nrZileConcediu: nrZileConcediu
            })



        }
    }


    openAdaugaEvenimentNou = (e = null) => {

        console.log('e :>> ', e);

        if (e) {
            this.setState({
                openUpdateEveniment: true,
                eveniment: e
            })
        } else {
            this.setState({
                openInsertEveniment: true,
                eveniment: { la_data: this.u.defaultData(), tip_concediu: '', prezenta: null, }
            })
        }


    }


    adaugaEvenimentNou = async () => {

        let _pontaje = this.ws.customSelect(`select * from pontaje where year(la_data) = year(@p1) and isnull(sters,0) != 1 and id_angajat = @p2`, {
            p1: this.props.dataStart,
            p2: this.props.angajat.id
        })

        let _concedii = this.ws.customSelect(`select c.*, p.id_angajat from concedii c left outer join pontaje p on p.id_concediu = c.id
        where year(c.cand_inceput_data) = year(@p1) OR year(c.cand_sfarsit_data) = year(@p1) and isnull(p.sters,0) != 1  and p.id_angajat = @p3` , {
            p1: this.props.dataStart,
            p2: this.props.dataEnd,
            p3: this.props.angajat.id
        })

        let [p, c] = await Promise.all([_pontaje, _concedii])

        if (p.Succes && c.Succes) {

            let pontaje = [...p.Content]

            let concedii = [...c.Content]

            let existaPontaj = false




            console.log('existaPontaj :>> ', existaPontaj);




            if (this.state.tipConcediu === 'prezent') {

                let dataPontaj = new Date(this.state.dataInceput)

                let sfarsitOraPontaj = this.props.angajat.program[dataPontaj.getDay()].end ? this.props.angajat.program[dataPontaj.getDay()].end : '18:00'



                let pontajToInsert = {


                    id_angajat: this.props.angajat.id,
                    id_cine_pontat: this.ls.GetUserData().IdUser,
                    la_data: this.state.dataInceput,
                    prezent_azi: 1,
                    cand_pontat: this.u.updateSqlNow(),
                    cand_inceput_ora: this.u.getTimeNow(),
                    cand_sfarsit_ora: sfarsitOraPontaj

                }

                for (let i = 0, n = pontaje.length; i < n; i++) {

                    console.log('this.m.sqlDateToJSDate(p[i].la_data) :>> ', this.m.sqlDateToJSDate(pontaje[i].la_data));
                    console.log('new Date(this.state.dataInceput) :>> ', new Date(this.state.dataInceput));
                    existaPontaj = this.m.datesAreEgual(this.m.sqlDateToJSDate(pontaje[i].la_data), new Date(this.state.dataInceput))

                    if (existaPontaj) {

                        let update = await this.ws.update('pontaje', { prezent_azi: 1, absent_azi: 0, absent_motivatie: 0 }, { id: pontaje[i].id })

                        if (update.Succes) {

                            this.setState({
                                openInsertEveniment: false,
                                dataInceput: this.u.defaultData(),
                                dataSfarsit: this.u.defaultData(),
                                tipConcediu: 'prezent',
                                oraInceput: '00:00',
                                oraFinalizare: '00:00',
                                existaPontaj: ''
                            }, () => {
                                this.getPontaje(this.props.angajat)
                            })

                            break;

                        }


                    }
                }


                if (!existaPontaj) {
                    let insertPontaj = await this.ws.insert('pontaje', pontajToInsert)

                    if (insertPontaj.Succes) {
                        this.setState({
                            openInsertEveniment: false,
                            dataInceput: this.u.defaultData(),
                            dataSfarsit: this.u.defaultData(),
                            tipConcediu: 'prezent',
                            oraInceput: '00:00',
                            oraFinalizare: '00:00',
                            existaPontaj: ''
                        }, () => {
                            this.getPontaje(this.props.angajat)
                        })


                    }
                }


            } else if (this.state.tipConcediu === 'absenta_nemotivata') {
                let pontajToInsert = {


                    id_angajat: this.props.angajat.id,
                    id_cine_pontat: this.ls.GetUserData().IdUser,
                    la_data: this.state.dataInceput,
                    absent_azi: 1,
                    cand_pontat: this.u.defaultData()

                }

                for (let i = 0, n = pontaje.length; i < n; i++) {

                    console.log('this.m.sqlDateToJSDate(p[i].la_data) :>> ', this.m.sqlDateToJSDate(pontaje[i].la_data));
                    console.log('new Date(this.state.dataInceput) :>> ', new Date(this.state.dataInceput));
                    existaPontaj = this.m.datesAreEgual(this.m.sqlDateToJSDate(pontaje[i].la_data), new Date(this.state.dataInceput))

                    if (existaPontaj) {

                        let update = await this.ws.update('pontaje', { prezent_azi: 0, absent_azi: 1, absent_motivatie: 0 }, { id: pontaje[i].id })

                        if (update.Succes) {

                            this.setState({
                                openInsertEveniment: false,
                                dataInceput: this.u.defaultData(),
                                dataSfarsit: this.u.defaultData(),
                                tipConcediu: 'prezent',
                                oraInceput: '00:00',
                                oraFinalizare: '00:00',
                                existaPontaj: ''
                            }, () => {
                                this.getPontaje(this.props.angajat)
                            })

                            break;

                        }


                    }
                }


                if (!existaPontaj) {
                    let insertPontaj = await this.ws.insert('pontaje', pontajToInsert)

                    if (insertPontaj.Succes) {
                        this.setState({
                            openInsertEveniment: false,
                            dataInceput: this.u.defaultData(),
                            dataSfarsit: this.u.defaultData(),
                            tipConcediu: 'prezent',
                            oraInceput: '00:00',
                            oraFinalizare: '00:00',
                            existaPontaj: ''
                        }, () => {
                            this.getPontaje(this.props.angajat)
                        })


                    }
                }
            } else if (this.state.tipConcediu === 'absenta_invoire') {

                let pontajToInsert = {


                    id_angajat: this.props.angajat.id,
                    id_cine_pontat: this.ls.GetUserData().IdUser,
                    la_data: this.state.dataInceput,
                    tip: this.state.tipConcediu,
                    cand_inceput_ora: this.state.oraInceput,
                    cand_sfarsit_ora: this.state.oraFinalizare,
                    cand_pontat: this.u.defaultData()

                }

                for (let i = 0, n = pontaje.length; i < n; i++) {

                    console.log('this.m.sqlDateToJSDate(p[i].la_data) :>> ', this.m.sqlDateToJSDate(pontaje[i].la_data));
                    console.log('new Date(this.state.dataInceput) :>> ', new Date(this.state.dataInceput));
                    existaPontaj = this.m.datesAreEgual(this.m.sqlDateToJSDate(pontaje[i].la_data), new Date(this.state.dataInceput))

                    if (existaPontaj) {

                        let update = await this.ws.update('pontaje', { prezent_azi: 0, absent_azi: 0, absent_motivatie: 0, tip: this.state.tipConcediu }, { id: pontaje[i].id })

                        if (update.Succes) {

                            this.setState({
                                openInsertEveniment: false,
                                dataInceput: this.u.defaultData(),
                                dataSfarsit: this.u.defaultData(),
                                tipConcediu: 'prezent',
                                oraInceput: '00:00',
                                oraFinalizare: '00:00',
                                existaPontaj: ''
                            }, () => {
                                this.getPontaje(this.props.angajat)
                            })

                            break;

                        }


                    }
                }


                if (!existaPontaj) {
                    let insertPontaj = await this.ws.insert('pontaje', pontajToInsert)

                    if (insertPontaj.Succes) {
                        this.setState({
                            openInsertEveniment: false,
                            dataInceput: this.u.defaultData(),
                            dataSfarsit: this.u.defaultData(),
                            tipConcediu: 'prezent',
                            oraInceput: '00:00',
                            oraFinalizare: '00:00',
                            existaPontaj: ''
                        }, () => {
                            this.getPontaje(this.props.angajat)
                        })


                    }
                }

            }



            else if (this.state.tipConcediu === 'invoire') {

                let pontajToInsert = {


                    id_angajat: this.props.angajat.id,
                    id_cine_pontat: this.ls.GetUserData().IdUser,
                    la_data: this.state.dataInceput,
                    tip: this.state.tipConcediu,
                    cand_inceput_ora: this.state.oraInceput,
                    cand_sfarsit_ora: this.state.oraFinalizare,
                    cand_pontat: this.u.defaultData()

                }

                for (let i = 0, n = pontaje.length; i < n; i++) {

                    console.log('this.m.sqlDateToJSDate(p[i].la_data) :>> ', this.m.sqlDateToJSDate(pontaje[i].la_data));
                    console.log('new Date(this.state.dataInceput) :>> ', new Date(this.state.dataInceput));
                    existaPontaj = this.m.datesAreEgual(this.m.sqlDateToJSDate(pontaje[i].la_data), new Date(this.state.dataInceput))

                    if (existaPontaj) {

                        let update = await this.ws.update('pontaje', { prezent_azi: 0, absent_azi: 0, absent_motivatie: 0, tip: this.state.tipConcediu }, { id: pontaje[i].id })

                        if (update.Succes) {

                            this.setState({
                                openInsertEveniment: false,
                                dataInceput: this.u.defaultData(),
                                dataSfarsit: this.u.defaultData(),
                                tipConcediu: 'prezent',
                                oraInceput: '00:00',
                                oraFinalizare: '00:00',
                                existaPontaj: ''
                            }, () => {
                                this.getPontaje(this.props.angajat)
                            })

                            break;

                        }


                    }
                }


                if (!existaPontaj) {
                    let insertPontaj = await this.ws.insert('pontaje', pontajToInsert)

                    if (insertPontaj.Succes) {
                        this.setState({
                            openInsertEveniment: false,
                            dataInceput: this.u.defaultData(),
                            dataSfarsit: this.u.defaultData(),
                            tipConcediu: 'prezent',
                            oraInceput: '00:00',
                            oraFinalizare: '00:00',
                            existaPontaj: ''
                        }, () => {
                            this.getPontaje(this.props.angajat)
                        })


                    }
                }

            }


            else if (this.state.tipConcediu === 'ore_suplimentare') {

                let pontajToInsert = {


                    id_angajat: this.props.angajat.id,
                    id_cine_pontat: this.ls.GetUserData().IdUser,
                    la_data: this.state.dataInceput,
                    tip: this.state.tipConcediu,
                    cand_inceput_ora: this.state.oraInceput,
                    cand_sfarsit_ora: this.state.oraFinalizare,
                    cand_pontat: this.u.defaultData(),
                    prezent_azi: 1,

                }

                for (let i = 0, n = pontaje.length; i < n; i++) {

                    console.log('this.m.sqlDateToJSDate(p[i].la_data) :>> ', this.m.sqlDateToJSDate(pontaje[i].la_data));
                    console.log('new Date(this.state.dataInceput) :>> ', new Date(this.state.dataInceput));
                    existaPontaj = this.m.datesAreEgual(this.m.sqlDateToJSDate(pontaje[i].la_data), new Date(this.state.dataInceput))

                    if (existaPontaj) {

                        let update = await this.ws.update('pontaje', { prezent_azi: 1, absent_azi: 0, absent_motivatie: 0, tip: this.state.tipConcediu }, { id: pontaje[i].id })

                        if (update.Succes) {

                            this.setState({
                                openInsertEveniment: false,
                                dataInceput: this.u.defaultData(),
                                dataSfarsit: this.u.defaultData(),
                                tipConcediu: 'prezent',
                                oraInceput: '00:00',
                                oraFinalizare: '00:00',
                                existaPontaj: ''
                            }, () => {
                                this.getPontaje(this.props.angajat)
                            })

                            break;

                        }


                    }
                }


                if (!existaPontaj) {
                    let insertPontaj = await this.ws.insert('pontaje', pontajToInsert)

                    if (insertPontaj.Succes) {
                        this.setState({
                            openInsertEveniment: false,
                            dataInceput: this.u.defaultData(),
                            dataSfarsit: this.u.defaultData(),
                            tipConcediu: 'prezent',
                            oraInceput: '00:00',
                            oraFinalizare: '00:00',
                            existaPontaj: ''
                        }, () => {
                            this.getPontaje(this.props.angajat)
                        })


                    }
                }

            }




            else {
                let concediuToAdd = {
                    cand_inceput_data: this.state.dataInceput,
                    cand_sfarsit_data: this.state.dataSfarsit,
                    tip_concediu: this.state.tipConcediu
                }


                let permisConcediu = true

                if (concediuToAdd['tip_concediu'] === 'concediu_odihna') {

                    console.log('this.state.angajat :>> ', this.props.angajat);
                    let dayDiff = this.u.getDaysDifference(this.state.dataSfarsit, this.state.dataInceput)

                    console.log('dayDiff :>> ', dayDiff);


                    if (Number(dayDiff) > Number(this.props.angajat['zile_concediu_ramase'])) {
                        permisConcediu = false
                    }

                }

                if (permisConcediu) {
                    for (let i = 0, n = pontaje.length; i < n; i++) {

                        console.log('this.m.sqlDateToJSDate(p[i].la_data) :>> ', this.m.sqlDateToJSDate(pontaje[i].la_data));
                        console.log('new Date(this.state.dataInceput) :>> ', new Date(this.state.dataInceput));
                        existaPontaj = (this.u.compareDate(this.m.sqlDateToJSDate(pontaje[i].la_data), new Date(this.state.dataInceput)) && this.u.compareDate(new Date(this.state.dataSfarsit), this.m.sqlDateToJSDate(pontaje[i].la_data)))

                        if (existaPontaj) {

                            let update = await this.ws.update('pontaje', { prezent_azi: 0, absent_azi: 0, absent_motivatie: 0 }, { id: pontaje[i].id })

                            if (update.Succes) {



                            }


                        }
                    }





                    let insertConcediu = await this.ws.insert('concedii', concediuToAdd)

                    if (insertConcediu.Succes) {


                        let insertPontaj = await this.ws.insert('pontaje', {
                            id_angajat: this.props.angajat.id,
                            id_cine_pontat: this.ls.GetUserData().IdUser,
                            la_data: this.state.dataInceput,
                            id_concediu: insertConcediu.Content[0].id
                        })

                        if (insertPontaj.Succes) {
                            this.setState({
                                openInsertEveniment: false,
                                dataInceput: this.u.defaultData(),
                                dataSfarsit: this.u.defaultData(),
                                tipConcediu: 'prezent',
                                oraInceput: '00:00',
                                oraFinalizare: '00:00',
                                existaPontaj: ''
                            }, () => {
                                this.getPontaje(this.props.angajat)
                            })

                        }


                    }
                } else {
                    this.props.openAlertConcediu(
                        {
                            openAlertConcediu: true,
                            alertConcediuTitlu: `Numar zile de concediu depasit!`,
                            alertConcediuMesaj: `Mai aveti ${this.props.angajat['zile_concediu_ramase']} de zile de concediu pentru acest utilizator.`
                        }
                    )
                }




            }



        }

    }



    goToEveniment = (eveniment) => {

        console.log('eveniment :>> ', eveniment);
        this.setState({
            openUpdateEveniment: true,
            eveniment: eveniment,
            dataInceput: this.u.ParseDataFromSql(eveniment.cand_inceput_dataC),
            dataSfarsit: this.u.ParseDataFromSql(eveniment.cand_sfarsit_dataC),
        })
    }



    updateEveniment = async () => {


        console.log(' :>> ',);

        let _pontaje = await this.ws.customSelect(`select * from pontaje where year(la_data) = year(@p1) and isnull(sters,0) != 1 and id_angajat = @p2`, {
            p1: this.props.dataStart,
            p2: this.props.angajat.id
        })

        if (_pontaje.Succes) {

            let pontaje = [..._pontaje.Content]

            let existaPontaj = false

            for (let i = 0, n = pontaje.length; i < n; i++) {

                console.log('this.m.sqlDateToJSDate(p[i].la_data) :>> ', this.m.sqlDateToJSDate(pontaje[i].la_data));
                console.log('new Date(this.state.dataInceput) :>> ', new Date(this.state.dataInceput));
                existaPontaj = (this.u.compareDate(this.m.sqlDateToJSDate(pontaje[i].la_data), new Date(this.state.dataInceput)) && this.u.compareDate(new Date(this.state.dataSfarsit), this.m.sqlDateToJSDate(pontaje[i].la_data)))

                if (existaPontaj) {

                    let update = await this.ws.update('pontaje', { prezent_azi: 0, absent_azi: 0, absent_motivatie: 0 }, { id: pontaje[i].id })

                    if (update.Succes) {



                    }


                }
            }

            let updateConcediu = await this.ws.update('concedii',
                {
                    cand_inceput_data: this.state.dataInceput,
                    cand_sfarsit_data: this.state.dataSfarsit,
                },
                { id: this.state.eveniment.id_concediu })

            if (updateConcediu.Succes) {
                this.setState({
                    eveniment: { la_data: this.u.defaultData(), tip_concediu: '', prezenta: null, id_concediu: '', },
                    openUpdateEveniment: false,
                    dataInceput: this.u.defaultData(),
                    dataSfarsit: this.u.defaultData(),
                    tipConcediu: 'prezent',
                    oraInceput: '00:00',
                    oraFinalizare: '00:00',
                    existaPontaj: ''
                }, () => {
                    this.getPontaje(this.props.angajat)
                })
            }

        }








    }

    stergeEveniment = async (eveniment) => {

        let stergeEveniment = await this.ws.update('pontaje',
            {
                sters: 1
            },
            { id: eveniment.id })

        if (stergeEveniment.Succes) {

            this.setState({
                eveniment: { la_data: this.u.defaultData(), tip_concediu: '', prezenta: null, id_concediu: '', },
                openUpdateEveniment: false,
                dataInceput: this.u.defaultData(),
                dataSfarsit: this.u.defaultData(),
                tipConcediu: 'prezent',
                oraInceput: '00:00',
                oraFinalizare: '00:00',
                existaPontaj: ''
            }, () => {
                this.getPontaje(this.props.angajat)
            })
        }
    }


    minusLuna = () => {

        let dataInceput = this.state.dataInceput

        let dataSfarsit = this.state.dataSfarsit


        dataInceput = new Date(this.state.dataInceput).setMonth(new Date(this.state.dataInceput).getMonth() - 1)
        dataSfarsit = new Date(this.state.dataSfarsit).setMonth(new Date(this.state.dataSfarsit).getMonth() - 1)

        dataInceput = new Date(dataInceput)
        dataSfarsit = new Date(dataSfarsit)

        console.log('dataInceput :>> ', dataInceput);
        console.log('dataSfarsit :>> ', dataSfarsit);

        this.setState({
            dataInceput: this.m.fistDayMonth(dataInceput),
            dataSfarsit: this.m.lastDayMonth(dataInceput),
            dataInceputPlus1: this.u.defaultDataPlus1Months(dataInceput),
            dataInceputMinus1: this.u.defaultDataMinus1Months(dataInceput),
        }, () => {
            this.getPontaje(this.props.angajat)
        })
    }


    plusLuna = () => {
        let dataInceput = this.state.dataInceput

        let dataSfarsit = this.state.dataSfarsit


        dataInceput = new Date(this.state.dataInceput).setMonth(new Date(this.state.dataInceput).getMonth() + 1)
        dataSfarsit = new Date(this.state.dataSfarsit).setMonth(new Date(this.state.dataSfarsit).getMonth() + 1)

        dataInceput = new Date(dataInceput)
        dataSfarsit = new Date(dataSfarsit)

        this.setState({
            dataInceput: this.m.fistDayMonth(dataInceput),
            dataSfarsit: this.m.lastDayMonth(dataInceput),
            dataInceputPlus1: this.u.defaultDataPlus1Months(dataInceput),
            dataInceputMinus1: this.u.defaultDataMinus1Months(dataInceput),
        }, () => {
            this.getPontaje(this.props.angajat)
        })
    }

    goToMonitorizare = (a) => {
        this.props.history.push(`monitorizareangajat/${a.id}`)
    }

    goToFisaAngajat = async (a) => {

        this.props.history.push(`/fisapersonalaangajat/${a.id}`)

    }

    changeView = () => {
        this.setState({
            peOLuna: !this.state.peOLuna,
            maxWidth: !this.state.peOLuna ? 'md' : 'lg'
        })
    }

    render() {
        return (
            <div>
                <Dialog
                    className="pm-alert-dialog"
                    disableEscapeKeyDown
                    fullWidth={true}
                    maxWidth={this.state.maxWidth}
                    open={this.props.open}
                    onClose={this.props.dialogClose}>
                    <DialogActions >
                        <Fab onClick={this.props.dialogClose} className="pm-round-button-dialog">
                            <i className='material-icons pm-round-button-text-dialog'>close</i>
                        </Fab>
                    </DialogActions>

                    <DialogContent>


                        {this.state.peOLuna &&
                            <Grid style={{ marginTop: 40 }} container>
                                <Grid style={{ marginBottom: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Grid container>
                                        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                            <Grid container>

                                                <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                    {
                                                        this.props.angajat.poza &&
                                                        <div
                                                            className='pm-angajati-picture'

                                                            style={{ backgroundImage: `url('${this.props.angajat.poza ? (new Ws().adresaMedia + '/Angajati/' + this.props.angajat.poza) : avatar}')`, width: 48, height: 48, padding: 5 }}>

                                                        </div>
                                                    }
                                                    {!this.props.angajat.poza &&

                                                        <Avatar
                                                            className='pm-angajati-picture'
                                                            style={{ display: 'flex', justifyContent: 'center', textAlign: 'center', height: 48, width: 48, backgroundColor: new Utils().culoriUtilizatori(this.props.angajat.id), padding: 5, cursor: 'pointer' }}>
                                                            {/* <i style={{ verticalAlign: '-webkit-baseline-middle', cursor: 'pointer' }} className='material-icons'>person</i> */}
                                                            <span style={{ display: 'block' }}>{this.numeAvatar(this.props.angajat.nume)} </span>
                                                        </Avatar>
                                                        // <Avatar onClick={this.props.userClick} style={{ display: 'inline-flex' }} className='pm-avatar'> {this.getLitereAvatar(u.nume + ' ')} </Avatar>
                                                    }
                                                </Grid>

                                                <Grid style={{ textAlign: 'left', paddingTop: 10, paddingLeft: 20 }} item xs={10} sm={10} md={10} lg={10} xl={10}>
                                                    <span style={{ fontWeight: 700, fontSize: 30 }}>    {this.props.angajat.nume}</span><br />

                                                </Grid>

                                            </Grid>
                                        </Grid>
                                        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                            <span style={{ display: 'block', marginBottom: 10, color: 'black', fontSize: 14, fontWeight: 500 }}><span style={{ color: 'rgb(176 176 176)', marginRight: 43 }}>{this.dictionary.pontaje.functie}:</span>{this.props.angajat.functie}</span>
                                            <span style={{ display: 'block', color: 'black', fontSize: 14, fontWeight: 500 }}><span style={{ color: 'rgb(176 176 176)', marginRight: 4 }}>{this.dictionary.pontaje.departament}:</span>{this.props.angajat.departament}</span>

                                        </Grid>

                                        {(this.ls.GetUserData().InfoUser.IsAdmin === 1 ? true : (this.ls.GetUserData().InfoUser.EsteSef === 1 ? true : false)) &&

                                            <Grid style={{ textAlign: 'right' }} item xs={4} sm={4} md={4} lg={4} xl={4}>
                                                <Fab className='pm-fab-green' style={{ marginRight: 20 }} onClick={() => { this.goToFisaAngajat(this.props.angajat) }}>
                                                    {/* <i className='material-icons'>folder</i> */}
                                                    <FaceBlack style={{ width: 24, height: 24, cursor: 'pointer', fill: 'white' }} />
                                                </Fab>
                                                <Fab className='pm-fab-green' onClick={() => { this.goToMonitorizare(this.props.angajat) }}>
                                                    <HistoryToggle style={{ width: 24, height: 24, cursor: 'pointer', fill: 'white' }} />
                                                </Fab>

                                            </Grid>
                                        }

                                    </Grid>
                                </Grid>

                                <Grid style={{ borderRight: '1px solid #e0e0e0' }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                    <Grid container>
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <span style={{ display: 'block', marginBottom: 10, color: 'black' }}><span style={{ color: 'rgb(176 176 176)' }}>{this.dictionary.pontaje.zileConcediuRamase}:</span>{this.props.angajat.zile_concediu_ramase}</span>
                                        </Grid>

                                        <Divider style={{ width: '90%' }} className='pm-divider' />

                                    </Grid>

                                    <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20, color: '#777777', fontSize: 16, fontWeight: 700 }} > {this.dictionary.pontaje.evenimenteAnulCurent}</h5>




                                        {this.state.pontaje.map((p, idx) => {
                                            if (p.tip_concediu) {
                                                return (
                                                    <Grid key={idx} style={{ marginBottom: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        <Grid container>
                                                            <Grid style={{ textAlign: 'center' }} item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                                <div style={{ backgroundColor: p.color, verticalAlign: 'middle', borderRadius: '50%', height: 24, width: 24, marginRight: 5 }} className='pm-task-legend'></div>
                                                            </Grid>
                                                            <Grid style={{ textAlign: 'left' }} item xs={7} sm={7} md={7} lg={7} xl={7}>
                                                                <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{p.nume_concediu}</span>


                                                                <span className='textSecondary' style={{ marginRight: 20, fontSize: 12, display: 'block', }}>
                                                                    {this.u.dataPrescurtataRomana(p.cand_inceput_dataC)} -  {this.u.dataPrescurtataRomana(p.cand_sfarsit_dataC)}</span>

                                                            </Grid>

                                                            <Grid style={{ textAlign: 'left' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                {(this.ls.GetUserData().InfoUser.IsAdmin === 1 ? true : (this.ls.GetUserData().InfoUser.EsteSef === 1 ? true : false)) &&
                                                                    <PenSolid className=' iconSvg' onClick={() => { this.goToEveniment(p) }} style={{ marginRight: 0, width: 18, height: 18 }} />
                                                                }

                                                                {(this.ls.GetUserData().InfoUser.IsAdmin === 1 ? true : (this.ls.GetUserData().InfoUser.EsteSef === 1 ? true : false)) &&
                                                                    <TrashAltSolid className=' iconSvg' onClick={() => { this.stergeEveniment(p) }} style={{ marginLeft: 10, width: 18, height: 18 }} />
                                                                }
                                                            </Grid>

                                                        </Grid>
                                                    </Grid>
                                                )
                                            }
                                        })}




                                        <Button
                                            style={{ width: '90%', }}

                                            className={'add-button-green'} onClick={() => { this.openAdaugaEvenimentNou(null) }}  >

                                            {this.dictionary.pontaje.adaugaEvenimentNou}
                                        </Button>

                                    </Grid>

                                </Grid>

                                <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                                    <ProgramatorLuni
                                        display={'block'}
                                        maxWidth={600}
                                        angajat={this.props.angajat}
                                        dataStart={this.state.dataInceput}
                                        minusLuna={this.minusLuna}
                                        plusLuna={this.plusLuna}
                                        evenimente={this.state.pontaje}
                                        changeView={this.changeView}
                                        changeble={true}
                                        openEveniment={this.goToEveniment}
                                        dataAzi={this.state.data}
                                    />

                                </Grid>

                            </Grid>

                        }


                        {!this.state.peOLuna &&
                            <Grid style={{ marginTop: 40 }} container>
                                <Grid style={{ marginBottom: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Grid container>
                                        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                            <Grid container>

                                                <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                    {
                                                        this.props.angajat.poza &&
                                                        <div
                                                            className='pm-angajati-picture'

                                                            style={{ backgroundImage: `url('${this.props.angajat.poza ? (new Ws().adresaMedia + '/Angajati/' + this.props.angajat.poza) : avatar}')`, width: 48, height: 48, padding: 5 }}>

                                                        </div>
                                                    }
                                                    {!this.props.angajat.poza &&

                                                        <Avatar
                                                            className='pm-angajati-picture'
                                                            style={{ display: 'flex', justifyContent: 'center', textAlign: 'center', height: 48, width: 48, backgroundColor: new Utils().culoriUtilizatori(this.props.angajat.id), padding: 5, cursor: 'pointer' }}>
                                                            {/* <i style={{ verticalAlign: '-webkit-baseline-middle', cursor: 'pointer' }} className='material-icons'>person</i> */}
                                                            <span style={{ display: 'block' }}>{this.numeAvatar(this.props.angajat.nume)} </span>
                                                        </Avatar>
                                                        // <Avatar onClick={this.props.userClick} style={{ display: 'inline-flex' }} className='pm-avatar'> {this.getLitereAvatar(u.nume + ' ')} </Avatar>
                                                    }
                                                </Grid>

                                                <Grid style={{ textAlign: 'left', paddingTop: 10, paddingLeft: 20 }} item xs={10} sm={10} md={10} lg={10} xl={10}>
                                                    <span style={{ fontWeight: 700, fontSize: 30 }}>    {this.props.angajat.nume}</span><br />

                                                </Grid>

                                            </Grid>
                                        </Grid>
                                        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                            <span style={{ display: 'block', marginBottom: 10, color: 'black' }}><span style={{ color: 'rgb(176 176 176)' }}>{this.dictionary.pontaje.functie}:</span>{this.props.angajat.functie}</span>
                                            <span style={{ display: 'block', color: 'black' }}><span style={{ color: 'rgb(176 176 176)' }}>{this.dictionary.pontaje.departament}:</span>{this.props.angajat.departament}</span>

                                        </Grid>

                                        <Grid style={{ textAlign: 'right' }} item xs={4} sm={4} md={4} lg={4} xl={4}>
                                            <Fab className='pm-fab-green' style={{ marginRight: 20 }} onClick={() => { this.goToFisaAngajat(this.props.angajat) }}>
                                                <i className='material-icons'>folder</i>
                                            </Fab>
                                            <Fab className='pm-fab-green' onClick={() => { this.goToMonitorizare(this.props.angajat) }}>
                                                <i className='material-icons'>assessment</i>
                                            </Fab>

                                        </Grid>

                                    </Grid>
                                </Grid>


                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <Grid container>
                                        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                            <ProgramatorLuni
                                                display={'block'}
                                                maxWidth={600}
                                                dataStart={this.state.dataInceputMinus1}
                                                minusLuna={this.minusLuna}
                                                plusLuna={this.plusLuna}
                                                evenimente={this.state.pontaje}
                                                changeView={this.changeView}
                                                changeble={true}
                                                angajat={this.props.angajat}
                                            />

                                        </Grid>
                                        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                            <ProgramatorLuni
                                                display={'block'}
                                                maxWidth={600}
                                                dataStart={this.state.dataInceput}
                                                minusLuna={this.minusLuna}
                                                plusLuna={this.plusLuna}
                                                evenimente={this.state.pontaje}
                                                changeView={this.changeView}
                                                changeble={true}
                                                angajat={this.props.angajat}
                                            />

                                        </Grid>
                                        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                            <ProgramatorLuni
                                                display={'block'}
                                                maxWidth={600}
                                                dataStart={this.state.dataInceputPlus1}
                                                minusLuna={this.minusLuna}
                                                plusLuna={this.plusLuna}
                                                evenimente={this.state.pontaje}
                                                changeView={this.changeView}
                                                changeble={true}
                                                angajat={this.props.angajat}
                                            />

                                        </Grid>

                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <span style={{ display: 'block', marginBottom: 10, marginTop: 10, color: 'black' }}><span style={{ color: 'rgb(176 176 176)' }}>{this.dictionary.pontaje.zileConcediuRamase}:</span>{this.state.nrZileConcediu}</span>
                                        </Grid>
                                        <Divider style={{ width: '100%' }} className='pm-divider' />
                                    </Grid>


                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>


                                    <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20, color: 'rgb(100	100	100)' }} > {this.dictionary.pontaje.evenimenteAnulCurent}</h5>




                                        {this.state.pontaje.map((p, idx) => {
                                            if (p.tip_concediu) {
                                                return (
                                                    <Grid key={idx} style={{ marginBottom: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        <Grid container>
                                                            <Grid style={{ textAlign: 'center' }} item xs={1} sm={1} md={1} lg={1} xl={1}>
                                                                <div style={{ backgroundColor: p.color, verticalAlign: 'middle', borderRadius: '50%', height: 24, width: 24, marginRight: 5 }} className='pm-task-legend'></div>
                                                            </Grid>
                                                            <Grid style={{ textAlign: 'left' }} item xs={10} sm={10} md={10} lg={10} xl={10}>
                                                                <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{p.nume_concediu}</span>
                                                                <span className='textSecondary' style={{ marginRight: 20, fontSize: 12, display: 'block', }}>
                                                                    {this.u.dataPrescurtataRomana(p.cand_inceput_dataC)} -  {this.u.dataPrescurtataRomana(p.cand_sfarsit_dataC)}</span>

                                                            </Grid>

                                                            <Grid style={{ textAlign: 'left' }} item xs={1} sm={1} md={1} lg={1} xl={1}>
                                                                <PenSolid className=' iconSvg' onClick={() => { this.goToEveniment(p) }} style={{ marginRight: 0, width: 18, height: 18 }} />
                                                                <TrashAltSolid className=' iconSvg' onClick={() => { this.stergeEveniment(p) }} style={{ marginLeft: 10, width: 18, height: 18 }} />
                                                            </Grid>

                                                        </Grid>
                                                    </Grid>
                                                )
                                            }
                                        })}




                                        <Button
                                            style={{ width: '100%', backgroundColor: '#07B14B' }}

                                            className={'add-button-green'} onClick={() => { this.openAdaugaEvenimentNou(null) }}  >

                                            {this.dictionary.pontaje.adaugaEvenimentNou}
                                        </Button>

                                    </Grid>

                                </Grid>



                            </Grid>

                        }

                    </DialogContent>


                </Dialog>


                {this.state.openInsertEveniment &&
                    <ConcediuDialogNew
                        open={this.state.openInsertEveniment}
                        dialogClose={() => { this.setState({ openInsertEveniment: false }) }}
                        angajat={this.props.angajat}
                        eveniment={this.state.eveniment}
                        dataInceput={this.state.dataInceput}
                        changeDataInceput={(ev) => { this.setState({ dataInceput: ev.target.value }) }}
                        dataSfarsit={this.state.dataSfarsit}
                        changeDataSfarsit={(ev) => { this.setState({ dataSfarsit: ev.target.value }) }}
                        tipEveniment={this.state.tipConcediu}
                        tipuriConcedii={this.state.tipuriConcedii}
                        changeTip={(ev) => { this.setState({ tipConcediu: ev.target.value }) }}
                        adaugaEvenimentNou={this.adaugaEvenimentNou}
                        oraInceput={this.state.oraInceput}
                        changeOraInceput={(ev) => { this.setState({ oraInceput: ev.target.value }) }}
                        oraFinalizare={this.state.oraFinalizare}
                        changeOraFinalizare={(ev) => { this.setState({ oraFinalizare: ev.target.value }) }}
                        existaPontaj={this.state.existaPontaj}
                        pontajDrepturi={this.props.pontajDrepturi}
                    />

                }



                {this.state.openUpdateEveniment &&
                    <ConcediuDialogNew
                        open={this.state.openUpdateEveniment}
                        dialogClose={() => { this.setState({ openUpdateEveniment: false }) }}
                        angajat={this.props.angajat}
                        eveniment={this.state.eveniment}
                        dataInceput={this.state.dataInceput}
                        changeDataInceput={(ev) => { this.setState({ dataInceput: ev.target.value }) }}
                        dataSfarsit={this.state.dataSfarsit}
                        changeDataSfarsit={(ev) => { this.setState({ dataSfarsit: ev.target.value }) }}
                        tipEveniment={this.state.tipConcediu}
                        tipuriConcedii={this.state.tipuriConcedii}
                        changeTip={(ev) => { this.setState({ tipConcediu: ev.target.value }) }}
                        adaugaEvenimentNou={this.updateEveniment}
                        oraInceput={this.state.oraInceput}
                        changeOraInceput={(ev) => { this.setState({ oraInceput: ev.target.value }) }}
                        oraFinalizare={this.state.oraFinalizare}
                        changeOraFinalizare={(ev) => { this.setState({ oraFinalizare: ev.target.value }) }}
                        existaPontaj={this.state.existaPontaj}
                        toUpdate={true}
                        stergeEveniment={this.stergeEveniment}
                        pontajDrepturi={this.props.pontajDrepturi}
                    />
                }

            </div>
        );
    }
}